/* Adapted from venn.js by Ben Frederickson
 * https://github.com/benfred/venn.js
 * Licensed under the MIT

 * url: https://github.com/benfred/venn.js/blob/master/src/circleintersection.js
 * License: https://github.com/benfred/venn.js/blob/master/LICENSE
 * @license
 */

export const SMALL = 1e-10;
